<template>
  <!-- Tabla -->
    
    <div class="flex justify-between mt-3">
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;GraficoTotalesCentro&#62;</span>
     <span class="text-lg text-indigo-500 font-mono   px-3 py-1 rounded-full shadow-sm">  AÑO {{ aa_consulta }}</span> 
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">  api/v1/presupuestos/centro </span>
    </div>
  <div class="overflow-x-auto">
      
        <highcharts :options="chartOptions"></highcharts>

     
  </div>
</template>

<script>
import api from "@/api/axios";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import "highcharts/modules/stock";
 
//const colors = Highcharts.getOptions().colors;
Highcharts.setOptions({
  chart: {

  },

});
import { useCatPresup } from "@/composables/useCatPresup";

export default {
  name: "TablaTotalesCentros",
  props: {
    centro_id: {
      type: Number,
      required: true
    },
     date_time: {
      type: String,
      
    },
     borrador:{
      type:Boolean
    }
  },
  mounted(){
      this.inicializar()
    this.categoriasAgrupadas()
   
  },
   watch: {
    date_time: function(){
         this.categoriasAgrupadas()
    },
    centro_id: function () {
     // console.log('montando', value, this.centro_id)
       this.categoriasAgrupadas()
    },
     
  },
  data() {
    return {
      chartOptions: {
        chart: { type: 'column' },
        title: { text: '' },
        xAxis: {
          categories: [],
          crosshair: true,
          accessibility: {
            description: ''
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        colors:['#7b41ba','#d600d2'],
        tooltip: {
          valueSuffix: ' CLP'
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: 'Presupuesto',
            data: []
          },
          {
            name: 'Gasto',
            data: []
          }
        ]


      },
      valor: "",
      listado: {},
      categorias: {},
      tipos: {}, 
      cuentamodif: 0,
      loading: true,
      total_presupuesto_centro: 0,
      presupuesto_categorias: [],
      total_gastos_centro: 0,
      aa_consulta:0
    } 
  },
  methods: {

   inicializar(){
        this.aa_consulta =  this.$store.state.auth.userLogin.año  
        if (this.borrador)
        {
            this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
        }
    },


     deprecated_categoriasAgrupadas() {
        console.log('hola')
    },
    async categoriasAgrupadas() {
      // recupera cuentas con presupuestos ingresados
      this.chartOptions.xAxis.categories=[]
      this.chartOptions.series=  [
          {
            name: 'Presupuesto',
            data: []
          },
          {
            name: 'Gasto',
            data: []
          }
        ]
      let presupuestos;
      try {
        const data = {
          centro_id: this.centro_id,
        };
         if (this.borrador){
          data["borrador"] = this.borrador
        }
        // solo trae presupuestos > 0
        const response = await api.post("api/v1/presupuestos/centro/", data, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          presupuestos = response.data.presupuestos;

          /*  
               contiene el mismo centro_id
               en todos sus registros

               los cuenta_id no se repiten
               
               "presupuestos": 
               [
                    {
                        "id": 5816,
                        "centro_id": 6,
                        "cuenta_id": 8,
                        "empresa_id": 1,
                        "aa": 2025,
                        "moneda_id": 1,
                        "total_presupuesto": "900000.00",
                        "total_gastos": "0.00"
                    },
                    
                  v/s   this.$store.state.cuentas.cuentas
                  [{
                    "id":112,
                    "codigo":"4.5.1030.80.44",
                    "nombre":"Alarma",
                    "tipo_cuenta":{
                    "id":13,
                    "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
                    "categoria_cuenta":{
                        "id":8,
                        "nombre":"GASTOS GENERALES"
                    }
                    }
                  */

         

          const cuentas = this.$store.state.cuentas.cuentas;
          const { getCatPresup } = useCatPresup();
          this.categorias = getCatPresup(presupuestos, cuentas);
     // ordenar por atributo 'orden'
        this.categorias = Object.values(this.categorias).sort((a, b) => 
          (a.orden ?? Infinity) -
          (b.orden ?? Infinity)
        );

          this.loading = false;
           
       

           
        }
/*
[
    {
        "id": 5,
        "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
        "tipos": [
            {
                "id": 8,
                "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
                "cuentas": [
                    {
                        "id": 36,
                        "cod": "4510305002",
                        "nomcta": "Folleteria",
                        "total_presupuesto": 300000,
                        "total_gastos": 0,
                        "saldo": 300000
                    },
                    {
                        "id": 40,
                        "cod": "4510305006",
                        "nomcta": "Eventos",
                        "total_presupuesto": 7300000,
                        "total_gastos": 8898,
                        "saldo": 7291102
                    },
                    {
                        "id": 41,
                        "cod": "4510305007",
                        "nomcta": "Fotografía",
                        "total_presupuesto": 500000,
                        "total_gastos": 0,
                        "saldo": 500000
                    }
                ]
            }
        ],
        "orden": 4
    },
 
]

*/
        this.presupuesto_categorias = this.categorias.map((grupo) => ({
          nombre: grupo.nombre,
          total_presupuesto: grupo.tipos
            .flatMap((t) => t.cuentas)
            .reduce((acc, c) => acc + Number(c.total_presupuesto), 0),
          total_gastos: grupo.tipos
                .flatMap(t => t.cuentas)
                .reduce((acc, c) => acc + Number(c.total_gastos || 0), 0),
        }));

       
         this.chartOptions.xAxis.categories = this.categorias.map(g => g?.nombre || '');
    
     
         
          this.presupuesto_categorias.forEach(cat => {
               
                this.chartOptions.series[0].data.push(cat.total_presupuesto)
                this.chartOptions.series[1].data.push(cat.total_gastos)
          });
 



       
            this.total_presupuesto_centro = this.presupuesto_categorias.reduce(
                (acc, cat) => acc + Number(cat.total_presupuesto),
                0
            );

            this.total_gastos_centro = this.presupuesto_categorias.reduce(
                (acc, cat) => acc + Number(cat.total_gastos),
                0
            );
            
      } catch (e) {
        console.error("Credenciales inválidas ❌", e);
      }
    },
  },
  components:{
     highcharts: Chart,
  }
};
</script>
